import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "searchFilter"
})
export class SearchPipe implements PipeTransform {
  transform(searchValue: any, toBeSearched?: any): any {
    if (!toBeSearched) {
      return searchValue;
    }
    return searchValue.filter(val => {
      try {
        for (let key of Object.keys(val)) {
          var value = val[key];
          if (Array.isArray(value)) {
            if (this.matchArray(value, toBeSearched))
              return this.matchArray(value, toBeSearched);
          } else if (typeof val[key] === "string") {
            if (this.matchValue(val[key], toBeSearched)) {
              return this.matchValue(val[key], toBeSearched);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  matchArray(value: any, toBeSearched: any) {
    return value.find(obj => {
      for (let subKey of Object.keys(obj)) {
        if (
          value != null &&
          typeof obj[subKey] === "string" &&
          this.matchValue(obj[subKey], toBeSearched)
        )
          return this.matchValue(obj[subKey], toBeSearched);
      }
    });
  }
  matchValue(value: any, toBeSearched: any) {
    return value.toLocaleLowerCase().includes(toBeSearched.toLocaleLowerCase());
  }
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/pipes/search.pipe.ts